export default{get name(){return"ExpoHaptics"}};